import {GridDataResult} from "@progress/kendo-angular-grid";
import {Injectable} from "@angular/core";
import {BehaviorSubject, catchError, map, Observable, tap, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {GiiRegFilterApi} from "../api/gii-registracija-filter.api";
import {SharedDataService} from "./shared-data.service";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GiiRegistracijaService extends BehaviorSubject<GridDataResult> {

  public loading!: boolean;
  private fetchFilteredGiiRegUrl = environment.apiBaseUrl + '/internalApi/fetchFilteredGiiReg';

  constructor(private http: HttpClient,
              private sharedDataService: SharedDataService
  ) {
    super({
      data: [],
      total: 0
    });
  }

  public queryFilteredGiiReg(filter: GiiRegFilterApi): void {
    this.fetchFilteredGiiReg(filter).subscribe((x) => super.next(x));
  }

  fetchFilteredGiiReg(filter: GiiRegFilterApi): Observable<GridDataResult> {
    this.loading = true;
    return this.http.post(this.fetchFilteredGiiRegUrl, filter, { withCredentials: true }).pipe(
      map(
        (response: any) =>
          <GridDataResult>{
            data: response.gridData,
            total: response.count,
          }
      ),
      catchError((error: any) => {
        console.error('Error:', error);
        this.sharedDataService.setKlaidos(error.error);
        return throwError(error);
      }),
      tap(() => (this.loading = false))
    );
  }
}
